module.exports = __webpack_public_path__ + "media/fc-billing-receipt-hint.d931eaff.png";